import { registerDefaultsForModule } from '@glu/theming';

// eslint-disable-next-line import/prefer-default-export
export const themeDefaults = () => ({
  breakpoint: 768,
  separation: 20,
});

registerDefaultsForModule('layout', themeDefaults);
